module.exports = __webpack_public_path__ + "img/five-5.6968b66b.png";